import React from "react";
import SabounDay from "./SabounDay";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Footer from "../Footer"; 
import image1 from "../../images/Images Webp/Blog-1.webp"
import image2 from "../../images/Images Webp/blog-2.webp"
import image3 from "../../images/Images Webp/blog3.webp"
import image4 from "../../images/Images Webp/tinywow_img_man_placing_eng_60034854.webp"

const Blog1 = () => {
  const photos = [
    { src: image1, alt: "Photo 1" },
    { src: image2, alt: "Photo 2" },
    { src: image3, alt: "Photo 3" },
    { src: image4, alt: "Photo 4" },
  ];

  const settings = {
    dots: true,
    infinite: true,
    speed: 1000, 
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true, 
    autoplaySpeed: 2000, 
  };

  return (
    <>
      <div className="min-h-screen p-8 bg-gray-50">
        <div className="max-w-6xl mx-auto bg-white rounded-lg shadow-xl p-8">
          <h1 className="text-orange-600 text-4xl font-extrabold mb-8 text-center">
            Avant le Jour du Mariage : Une Semaine de Préparation et de
            Célébration dans les Mariages Tunisiens
          </h1>
          <Slider {...settings} className="mb-8">
            {photos.map((photo, index) => (
              <div key={index}>
                <img
                  src={photo.src}
                  alt={photo.alt}
                  className="w-full h-auto rounded-lg shadow-md object-cover"
                />
              </div>
            ))}
          </Slider>
          <SabounDay />
        </div>
      </div>
      <Footer />
    </>
  );
};

export default Blog1;
